import { IReleaseNote } from "../types"

export const RELEASE_2_0_4: IReleaseNote = {
    status: "PAST",
    title: "v2.0.4",
    date: "09th December 2025",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This is a patch release to onboard iDNO Green GEN Cymru onto ENA Connect Direct!",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "You can now submit applications for customers in the Green GEN Cymru license area",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been added:",
            bullets: [
                "You can now submit applications for customers in the Green GEN Cymru license area",
                "The abbreviation for this iDNO is 'I-GGC'",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
